<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-autocomplete
          :style="isMobile ? 'width: 280px !important;' : ''"
          v-model="filters.name"
          :fetch-suggestions="querySearch"
          placeholder="医院名称"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="">
        <el-autocomplete
          :style="isMobile ? 'width: 280px !important;' : ''"
          v-model="filters.bwacctnumber"
          :fetch-suggestions="querySearch2"
          placeholder="ZCN ID"
        ></el-autocomplete>
      </el-form-item>
      <div v-if="isMobile"></div>
      <el-form-item :style="isMobile ? 'width: 250px !important' : ''" v-if="GLY_IF" label="">
        <el-select v-model="filters.HCO_Status" clearable placeholder="停用状态">
          <el-option label="停用" :value="true"></el-option>
          <el-option label="启用" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
      <!-- <el-upload v-if="PLGX_IF" style="display:inline-block;margin-right:20px;padding-bottom:12px"
              class="upload-demo" ref="upload" action="/images/Upload/file" :headers="token" :show-file-list="false"
              :on-success='handleSuccess' :before-upload='handlebefore' :on-error='handonerror'>
              <el-button type="primary">批量更新</el-button>
            </el-upload> -->
    </el-form>
    <!--列表-->
    <div class="table_top_div">
      <div>
        <el-table
          v-if="!isMobile"
          border
          :max-height="tableHeight"
          :data="users"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
        >
          <!-- <el-table-column sortable type="selection" width="50">
        </el-table-column>-->
          <el-table-column type="index" width="80">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                序号
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
              <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
            </template>
          </el-table-column>
          <el-table-column sortable prop="BWAcctNumber" label="ZCN ID" min-width="130"></el-table-column>
          <el-table-column sortable prop="Name" label="医院名称" min-width="220"></el-table-column>
          <!-- <el-table-column sortable prop="original_name" label="医院曾用名" width="220"></el-table-column> -->
          <!-- <el-table-column sortable prop="invoice_name" label="发票名称" width="220"></el-table-column> -->
          <!-- <el-table-column sortable prop="Address" label="医院地址" min-width="260"></el-table-column> -->
          <el-table-column sortable prop="province_name" label="省份" min-width="120"></el-table-column>
          <!-- <el-table-column sortable prop="cityid" label="城市" width=""></el-table-column> -->
          <el-table-column prop="city_name" label="城市" min-width="100">
            <template slot="header" slot-scope="{}">
              <span style="padding: 0px 0; height: 34px; display: inline-block; line-height: 32px">
                城市
                <i @click="cp_zk_click" style="cursor: pointer" :class="HCO_LIST_IF ? 'el-icon-remove' : 'el-icon-circle-plus'"></i>
              </span>
              <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
            </template>
          </el-table-column>
          <!-- <div v-if="HCO_LIST_IF"> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="is_private" label="公私立" width="120">
              <template scope="scope">
                {{ scope.row.is_private ? '私立' : '公立' }}
              </template>
            </el-table-column> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="sales_region_large_name" label="大区" width=""></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="sales_region_small_name" label="小区" width=""></el-table-column>
          <el-table-column sortable prop="release_type" label="释放岗位号类型" width="180"></el-table-column>
          <el-table-column sortable prop="old_position_code_user" label="原负责人" width="180"></el-table-column>
          <el-table-column sortable prop="approoval_status" label="审批状态" width="180"></el-table-column>
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="Category" label="类型" width=""></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="level" label="级别" width=""></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="crystal_position_code" label="晶体销售岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="crystal_position_code_name" label="晶体销售" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="facility_position_code" label="CD临床应用发展岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="facility_position_code_name" label="设备销售" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_crystal_position_code" label="REF销售岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_crystal_position_code_name" label="REF销售" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="cat_crystal_position_code_name" label="Cat销售" width="120"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="cat_Group" label="白内障私立医院集团" width="200"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_Group" label="屈光飞白私立医院集团" width="200"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="IsContainsEyes" label="执业范围是否包含眼科相关" width="220"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="license_life" label="执业许可有效期" width="180"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="business_life" label="营业许可有效期" width="180"></el-table-column> -->
          <!-- </div> -->
          <!-- <el-table-column sortable prop="status" label="审批状态" width="120">
            <template scope="scope">
              <el-tag :type="scope.row.status == 0 ? 'success' : scope.row.status == 1 ? 'warning' : 'danger'">
                {{
                  scope.row.status == 0 ? '审批通过' : scope.row.status == 1 ? '审批中' : scope.row.approval_cancel_is == true ? '撤回' : '审批驳回'
                }}
              </el-tag>
            </template>
          </el-table-column> -->
          <el-table-column sortable prop="status" label="认领状态" width="120">
            <template scope="scope">
              {{
                scope.row.status == 'released'
                  ? '释放'
                  : scope.row.status == 'claimed_by_region'
                  ? '大区经理认领'
                  : scope.row.status == 'claimed_by_area'
                  ? '小区经理认领'
                  : scope.row.status == 'claimed_by_salesperson'
                  ? '一线销售认领'
                  : ''
              }}
            </template>
          </el-table-column>
          <!-- <el-table-column sortable prop="business_life" label="验证状态" width="120">
              <template scope="scope">
                <el-tag :type="scope.row.CheckStatus == 1 ? 'warning' : scope.row.CheckStatus == 2 ? 'success' : 'danger'">
                  {{ scope.row.CheckStatus == 1 ? '未验证' : scope.row.CheckStatus == 2 ? '验证通过' : '未通过' }}
                </el-tag>
              </template>
            </el-table-column> -->
          <el-table-column label="操作" width="260">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                操作
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
            </template>
            <template scope="scope">
              <!-- <el-link type="primary" @click="handledetails(scope.row)">
                <i class="el-icon-tickets"></i>
                查看 ｜
              </el-link> -->
              <el-link @click="click_operate" type="primary">
                <!-- &nbsp;|&nbsp; -->
                <i class="el-icon-edit"></i>
                认领
              </el-link>
              <!-- <el-link type="primary" v-if="EDIT_IF && (scope.row.status == 0 || scope.row.status == -1)" @click="handleEdit(scope.row)">
                  &nbsp;|&nbsp;
                  <i class="el-icon-edit"></i>
                  编辑
                </el-link>
                <el-link type="primary" v-if="HBSC_IF && (scope.row.status == 0 || scope.row.status == -1)" @click="handleEdit(scope.row, 'HBSC')">
                  &nbsp;|&nbsp;
                  <i class="el-icon-edit"></i>
                  合并/删除
                </el-link>
                <el-link type="primary" v-if="EDIT_BCXX_IF && (scope.row.status == 0 || scope.row.status == -1)" @click="handleEdit(scope.row, 'BCXX')">
                  &nbsp;|&nbsp;
                  <i class="el-icon-edit"></i>
                  编 辑
                </el-link>
                <el-link type="danger" v-if="EDIT_IF && scope.row.approval_cancel" @click="handleRefresh(scope.row)">
                  &nbsp;|&nbsp;
                  <i class="el-icon-refresh-left"></i>
                  撤回申请
                </el-link> -->
            </template>
          </el-table-column>
        </el-table>

        <!-- mobel -->
        <el-table
          v-if="isMobile"
          border
          :max-height="tableHeight"
          :data="users"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
        >
          <!-- <el-table-column sortable type="selection" width="50">
        </el-table-column>-->
          <!-- <el-table-column type="index" width="80">
          <template slot="header" slot-scope="{}">
            <span style="padding: 8px 0">序号 
             <span class="caret-wrapper" style="width:0px"></span>
              </span>
          </template>
        </el-table-column> -->

          <el-table-column label="操作" width="160">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                操作
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
            </template>
            <template scope="scope">
              <el-link type="primary" @click="handledetails(scope.row)">
                <i class="el-icon-tickets"></i>
                详情
              </el-link>
              <el-link type="primary" v-if="EDIT_IF && (scope.row.status == 0 || scope.row.status == -1)" @click="handleEdit(scope.row)">
                &nbsp;|&nbsp;
                <i class="el-icon-edit"></i>
                编辑
              </el-link>
              <!-- <el-link type="primary" v-if="HBSC_IF && (scope.row.status ==0 ||scope.row.status ==-1)" @click="handleEdit(scope.row,'HBSC')">&nbsp;|&nbsp;<i class="el-icon-edit"></i>合并/删除</el-link> -->
            </template>
          </el-table-column>
          <el-table-column prop="Name" label="医院名称" min-width="220"></el-table-column>

          <!-- <el-table-column sortable prop="original_name" label="医院曾用名" width="220"></el-table-column> -->
          <!-- <el-table-column sortable prop="invoice_name" label="发票名称" width="220"></el-table-column> -->
          <el-table-column sortable prop="Address" label="医院地址" min-width="220"></el-table-column>
          <!-- <el-table-column sortable prop="Name" label="医院负责人" min-width="220"></el-table-column> -->
          <el-table-column sortable prop="BWAcctNumber" label="ZCN ID" min-width="160"></el-table-column>
          <el-table-column sortable prop="province_name" label="省份" min-width="160"></el-table-column>
          <!-- <el-table-column sortable prop="cityid" label="城市" width=""></el-table-column> -->
          <el-table-column prop="city_name" label="城市" min-width="100">
            <template slot="header" slot-scope="{}">
              <span style="padding: 0px 0; height: 34px; display: inline-block; line-height: 32px">
                城市
                <i @click="cp_zk_click" style="cursor: pointer" :class="HCO_LIST_IF ? 'el-icon-remove' : 'el-icon-circle-plus'"></i>
              </span>
              <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
            </template>
          </el-table-column>
          <!-- <div v-if="HCO_LIST_IF"> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="is_private" label="公私立" width="120">
            <template scope="scope">
              {{ scope.row.is_private ? '私立' : '公立' }}
            </template>
          </el-table-column> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="sales_region_large_name" label="大区" width=""></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="sales_region_small_name" label="小区" width=""></el-table-column>
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="Category" label="类型" width=""></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="level" label="级别" width=""></el-table-column> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="crystal_position_code" label="晶体销售岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="crystal_position_code_name" label="晶体销售" width="120"></el-table-column>
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="facility_position_code" label="CD临床应用发展岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="facility_position_code_name" label="设备销售" width="120"></el-table-column> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_crystal_position_code" label="REF销售岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_crystal_position_code_name" label="REF销售" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="cat_crystal_position_code" label="飞白设备销售岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="cat_crystal_position_code_name" label="Cat销售" width="120"></el-table-column>
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="pd_position_code" label="PPD先进术式发展岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="pd_position_code_name" label="PPD销售" width="120"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="cat_Group" label="白内障私立医院集团" width="200"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_Group" label="屈光飞白私立医院集团" width="200"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="IsContainsEyes" label="执业范围是否包含眼科相关" width="220"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="license_life" label="执业许可有效期" width="180"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="business_life" label="营业许可有效期" width="180"></el-table-column> -->
          <!-- </div> -->
          <el-table-column sortable prop="status" label="审批状态" width="120">
            <template scope="scope">
              <el-tag :type="scope.row.status == 0 ? 'success' : scope.row.status == 1 ? 'warning' : 'danger'">
                {{
                  scope.row.status == 0 ? '审批通过' : scope.row.status == 1 ? '审批中' : scope.row.approval_cancel_is == true ? '撤回' : '审批驳回'
                }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column sortable prop="business_life" label="验证状态" width="120">
            <template scope="scope">
              <el-tag :type="scope.row.CheckStatus == 1 ? 'warning' : scope.row.CheckStatus == 2 ? 'success' : 'danger'">
                {{ scope.row.CheckStatus == 1 ? '未验证' : scope.row.CheckStatus == 2 ? '验证通过' : '未通过' }}
              </el-tag>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
          <el-pagination
            :current-page="page"
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="50"
            :total="total"
            style="float: right"
          ></el-pagination>
        </el-col>
      </div>
    </div>
    <!--工具条-->
    <el-dialog title="医院批量更新" :visible.sync="dialogVisible1" width="30%" :before-close="handleClose">
      <el-form ref="form1" :model="form1" :rules="editFormRules1" label-width="80px" label-position="left">
        <el-form-item label="立即生效" :required="true">
          <el-switch @change="isimediate_change" v-model="form1.isimediate"></el-switch>
        </el-form-item>
        <el-form-item label="生效日期" :required="true">
          <el-date-picker :disabled="form1.isimediate" v-model="form1.date" type="date" placeholder="请选择"></el-date-picker>
        </el-form-item>
        <el-upload
          style="display: inline-block; margin-right: 20px; padding-bottom: 12px"
          class="upload-demo"
          ref="upload"
          action="/images/Upload/Flie"
          :headers="token"
          :show-file-list="false"
          :on-success="handleSuccess"
          :before-upload="handlebefore"
          :on-error="handonerror"
        >
          <el-button type="primary">上传</el-button>
          <el-button @click="btn_up_2(form1.filepath)" v-if="form1.filepath" type="primary">预览</el-button>
        </el-upload>
        <br />
        <el-button type="primary" @click="plmb_dc">模版导出</el-button>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="plgx_submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="模板导出" :visible.sync="mbdcdialogVisible" width="30%" :before-close="handleClose">
      <el-form label-width="80px" label-position="left">
        <el-form-item label="版本号">
          <el-select v-model="mbdc_version" placeholder="不选为当前版本">
            <el-option v-for="item in VersionList_list" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mbdcdialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="mbdcdialogVisible_submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导出" :visible.sync="DC_MODE" width="30%" :before-close="handleClose">
      <el-form ref="dc_form" :model="dc_form" :rules="editFormRules1" label-width="160px" label-position="left">
        <el-form-item label="大区/小区">
          <el-cascader
            clearable
            v-model="dc_form.Level_3and4"
            :options="Employee_list"
            :props="{ value: 'ID', label: 'Name', checkStrictly: true }"
            @change="Level_3and4Change"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="省份">
          <el-select clearable v-model="dc_form.province_name" @change="province_change($event)" placeholder="请选择">
            <el-option v-for="item in region_list" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市">
          <el-select clearable v-model="dc_form.city_name" @change="city_change($event)" placeholder="请选择">
            <el-option v-for="item in city_list" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="晶体岗位号">
          <!-- <el-select v-model="dc_form.Postcode"></el-select> -->
          <el-input v-model="dc_form.crystal_position_code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="REF岗位号">
          <!-- <el-select v-model="dc_form.Postcode"></el-select> -->
          <el-input v-model="dc_form.ref_crystal_position_code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="白内障私立医院集团">
          <!-- <el-select v-model="dc_form.dioptrics_group"></el-select> -->
          <!-- <el-input v-model="dc_form.cat_Group" placeholder="请输入"></el-input> -->
          <el-select clearable v-model="dc_form.cat_Group" placeholder="请选择">
            <el-option v-for="item in CatGroup_list" :key="item.ID" :label="item.ShowName" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="屈光飞白私立医院集团">
          <!-- <el-select v-model="dc_form.dioptrics_group"></el-select> -->
          <!-- <el-input v-model="dc_form.dioptrics_group" placeholder="请输入"></el-input> -->
          <el-select clearable v-model="dc_form.dioptrics_group" placeholder="请选择">
            <el-option v-for="item in RefGroup_list" :key="item.ID" :label="item.ShowName" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-row v-if='HCO_IF != "ADD"'> -->
        <!-- <el-col :span="7" :xs="24"> -->
        <el-form-item label="停用">
          <el-select v-model="dc_form.HCO_Status" clearable placeholder="请输入">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <!-- </el-col> -->
        <!-- </el-row> -->
        <el-form-item label="版本号">
          <el-select v-model="dc_form.version" placeholder="不选为当前版本">
            <el-option v-for="item in VersionList_list" :key="item" :label="item" :value="item"></el-option>
            <!-- <el-option  label="202309" value="202309"></el-option> -->
          </el-select>
        </el-form-item>
        <!-- <el-button type="primary"  @click="mode_uplode">导出</el-button> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DC_MODE = false">关 闭</el-button>
        <el-button type="primary" @click="mode_uplode">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '@/../util/date'
import {
  HcoGetVersionList,
  Hco_QueryPage_Claim,
  HcoHcoInfoExportExcel,
  store_data_Reback_Store,
  HcoHcoExportExcel,
  regionGetRegionTree,
  EmployeeRegionGetEmployeeRegionTrees,
  HcoImprotUpdateList,
  HcoGetHcoCatGroup,
  HcoApprovalCancel,
  HcoGetHcoRefGroup,
} from '@/api/api'
import { getButtonList } from '@/promissionRouter'
import Toolbar from '@/components/Toolbar'
// import { number } from 'echarts/lib/export'

export default {
  components: { Toolbar },
  data() {
    return {
      EDIT_BCXX_IF: false,
      name_list: [],
      zcn_list: [],
      GLY_IF: false,
      isMobile: false,
      HBSC_IF: false,
      VersionList_list: [],
      mbdc_version: '',
      mbdcdialogVisible: false,
      dc_form: {},
      CatGroup_list: [],
      RefGroup_list: [],
      Employee_list: [],
      DC_MODE: false,
      tableHeight: 0,
      currentPage2: 5,
      editFormRules1: {
        Code: [{ required: true, message: '请选择', trigger: 'blur' }],
        RID: [{ required: true, message: '请选择', trigger: 'blur' }],
        PREID: [{ required: true, message: '请选择', trigger: 'blur' }],
        Name: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      form1: {
        isimediate: false,
        filepath: '',
        date: '',
      },
      LJGX: true,
      dialogVisible1: false,
      token: {},
      PLGX_IF: false,
      HCO_LIST_IF: false,
      SalesOperation_if: false,
      edit_if_2: false,
      EDIT_IF: false,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      users: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      region_list: [],
      city_list: [],
      sels: [], //列表选中列
    }
  },
  methods: {
    click_operate() {
      this.$confirm('确定认领?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          //   this.$message({
          //     type: 'success',
          //     message: '删除成功!',
          //   })
        })
        .catch(() => {
          //   this.$message({
          //     type: 'info',
          //     message: '已取消删除',
          //   })
        })
    },
    plmb_dc() {
      location.href =
        'https://share-ui.oss-cn-shanghai.aliyuncs.com/202308_JJSVMDM/data_template/%E5%8C%BB%E9%99%A2%E6%89%B9%E9%87%8F%E6%9B%B4%E6%96%B0_%E6%A8%A1%E6%9D%BF.xlsx'
    },
    storage_data() {
      if (this.filters.name) {
        if (this.name_list.length == 15) {
          this.name_list.splice(14, 1)
        }
        for (var i in this.name_list) {
          console.log(this.name_list[i].value)
          console.log(this.filters.name)
          if (this.name_list[i].value == this.filters.name) {
            this.name_list.splice(i, 1)
            console.log(this.name_list)
          }
        }
        this.name_list.unshift({
          value: this.filters.name,
        })
      }
      if (this.filters.bwacctnumber) {
        if (this.zcn_list.length == 15) {
          this.zcn_list.splice(14, 1)
        }
        for (var i in this.zcn_list) {
          if (this.zcn_list[i].value == this.filters.bwacctnumber) {
            this.zcn_list.splice(i, 1)
          }
        }
        this.zcn_list.unshift({
          value: this.filters.bwacctnumber,
        })
      }

      //  var name_list = JSON.
      // JSON.parse
      // JSON.stringify
      localStorage.setItem('name_list', JSON.stringify(this.name_list))
      localStorage.setItem('zcn_list', JSON.stringify(this.zcn_list))
      console.log(localStorage.getItem('name_list'))
    },
    querySearch(queryString, cb) {
      var restaurants = this.name_list
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    querySearch2(queryString, cb) {
      var restaurants = this.zcn_list
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    isimediate_change(e) {
      if (e == true) {
        this.form1.date = ''
      }
    },
    async plgx_submit() {
      // if(this.form1.isimediate){
      //     this.form1.date =''
      // }
      if (!this.form1.isimediate && !this.form1.date) {
        this.$message({
          message: '请选择生效时间',
          type: 'error',
        })
        return
      }
      if (!this.form1.filepath) {
        this.$message({
          message: '请上传批量更新文件',
          type: 'error',
        })
        return
      }
      const { data } = await HcoImprotUpdateList(this.form1)
      if (data.success) {
        this.$message({
          message: data.msg,
          type: 'success',
        })
        this.getModules_search()
        this.dialogVisible1 = false
      } else {
        this.$message({
          message: data.msg,
          type: 'error',
        })
      }
    },
    btn_up_2(e) {
      window.open('https://preview.51i.cc/onlinePreview?url=' + encodeURIComponent('https://' + location.host + '/' + e))
    },
    async EmployeeRegionGetEmployeeRegionTrees_fn() {
      const { data } = await EmployeeRegionGetEmployeeRegionTrees()
      this.Employee_list = data.response
    },
    Level_3and4Change(e) {
      if (!e) {
        return
      }
      this.dc_form.sales_region_id = e[e.length - 1]
      console.log(this.dc_form.sales_region_id)
    },
    async regionGetRegionTree_fn() {
      const { data } = await regionGetRegionTree()
      this.region_list = data.response
    },
    city_change(e) {
      this.city_list.find((item) => {
        if (item.name === e) {
          this.dc_form.cityid = item.id
          // this.city_list = item.children
        }
      })
    },
    province_change(e) {
      this.region_list.find((item) => {
        if (item.name === this.dc_form.province_name) {
          this.dc_form.ProvinceID = item.id
          this.city_list = item.children
          console.log(this.city_list)
          console.log(this.dc_form.ProvinceID)
        }
      })
    },
    all_upload() {
      this.dialogVisible1 = true
    },
    handleClose(done) {
      done()
    },
    handlebefore(file) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      const isLt1M = file.size / 1024 / 1024 < 20

      // if (!isJPG) {
      //   this.$message.error('上传文件只能是 JPG 格式!')
      // }
      if (!isLt1M) {
        this.$message.error('上传文件大小不能超过 20MB!')
      }
      loading.close()
      return isLt1M
    },
    handonerror() {
      console.log('超时失败')

      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      this.$message({
        message: '您的上传已超时，请再次尝试',
        type: 'error',
      })
      loading.close()
    },
    handleSuccess(file, fileLis) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      if (file.success) {
        this.form1.filepath = file.response
        // this.UPLOAD_IF = true
        loading.close()
        this.$message({
          message: file.msg,
          type: 'success',
        })
        this.$refs.upload.clearFiles()
      } else {
        loading.close()
        this.$message({
          message: file.msg,
          type: 'error',
        })
        this.$refs.upload.clearFiles()
      }
    },
    cp_zk_click() {
      if (this.HCO_LIST_IF) {
        this.HCO_LIST_IF = false
      } else {
        this.HCO_LIST_IF = true
      }
    },
    HcoApprovalCancel_fn(row) {
      HcoApprovalCancel(row).then((res) => {
        if (res.data.success) {
          this.$message({
            message: '撤回成功',
            type: 'success',
          })
          this.getModules_search()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handleRefresh(row) {
      this.$confirm('确定撤回该申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.HcoApprovalCancel_fn(row)
        })
        .catch(() => {
          //   this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          //   });
        })
    },
    mbdcdialogVisible_submit() {
      let para = this.filters
      HcoHcoExportExcel({
        version: this.mbdc_version,
      }).then((res) => {
        this.mbdcdialogVisible = false
        window.open('/api' + res.data.response)
        // window.location.href =
      })
    },
    all_ExportAccount() {
      this.mbdcdialogVisible = true
    },
    mode_uplode() {
      let para = this.dc_form
      console.log(para)
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      HcoHcoInfoExportExcel(para).then((res) => {
        if (res.data.status == 200) {
          this.DC_MODE = false
        }
        loading.close()
        window.open('/api' + res.data.response)
      })
    },
    ExportAccount() {
      this.DC_MODE = true
      this.dc_form = {}
      this.HcoGetHcoCatGroup_fn()
      this.HcoGetHcoRefGroup_fn()
      this.regionGetRegionTree_fn()
      this.EmployeeRegionGetEmployeeRegionTrees_fn()
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    // 导出
    // ExportAccount() {
    //   // let para = this.filters
    //   let para = {};
    //   //  para.account_manager = para.account_manager.toString()
    //   //  window.open("​/api​/store_data​/ExportStore?")
    //   store_data_ExportStore(para).then((res) => {
    //     //window.open("http://47.103.87.196:8082" + res.data.msg);
    //     window.location.href = res.data.msg;
    //   });
    // },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? '正常' : '未知'
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == '' ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd')
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.filters.pageSize = val
      this.getModules()
    },
    handleCurrentChange(val) {
      this.page = val
      //   console.log(val)
      this.getModules()
    },
    getModules_search() {
      this.page = 1
      this.storage_data()
      this.getModules()
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      console.log(para)
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      this.listLoading = true
      Hco_QueryPage_Claim(para).then((res) => {
        this.total = res.data.response.dataCount
        this.users = res.data.response.data
        this.listLoading = false
      })
    },
    //删除
    handleDel(ids) {
      console.log(ids)
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          this.listLoading = true
          //NProgress.start();
          let para = { id: ids }
          channel_Delete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false
              return
            }
            this.listLoading = false
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: '删除成功',
                type: 'success',
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }

            this.getModules()
          })
        })
        .catch(() => {})
    },
    handleWithdraw(id) {
      // 撤回
      store_data_Reback_Store('store_id=' + id).then((res) => {
        if (res.data.success) {
          this.$message({
            message: '撤回成功',
            type: 'success',
          })
          this.getModules()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handledetails: function (e) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/HCO/HCO_details',
        query: {
          id: e.ID,
          approval_data_id: e.approval_data_id,
          type: 'CK',
          back_url: '/HCO/claim_release/claim',
          filters_list: this.filters,
          claim_release: 'claim',
        },
      })
    },
    //编辑
    handleEdit: function (e, type) {
      // console.log(id)
      // return
      var types = 'EDIT'
      if (type == 'HBSC') {
        types = 'CK'
      }
      this.$router.push({
        path: '/HCO/HCO_details',
        query: {
          id: e.ID,
          type: types,
          status: type,
          back_url: '/HCO/HCO_list',
          filters_list: this.filters,
        },
      })
    },
    handleAdd() {
      this.$router.push({
        path: '/HCO/HCO_details',
        query: {
          type: 'ADD',
          back_url: '/HCO/HCO_list',
        },
      })
    },

    handledetails_SalesOperation: function (ids, progress, outletnumber__c) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/StoreManage/add_store',
        query: {
          id: ids,
          type: 'store_ck',
          progress: progress,
          approval_type: 'store',
          outletnumber__c: outletnumber__c,
          list_SalesOperation: 1,
        },
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    //localStorage 存储数组对象的方法
    saveObjArr(name, data) {
      localStorage.setItem(name, JSON.stringify(data))
    },

    //localStorage 获取数组对象的方法
    getObjArr(name) {
      return JSON.parse(window.localStorage.getItem(name))
    },
    details_tag(name) {
      var router_list = this.getObjArr('router')
      for (let i in router_list) {
        for (let s in router_list[i].children) {
          //  console.log(999)
          if (router_list[i].children[s].id == '175') {
            //  console.log(999)
            router_list[i].children[s].name = name
            router_list[i].children[s].meta.title = name
            console.log(router_list[i].children[s].name)
            this.saveObjArr('router', router_list)
            console.log(this.getObjArr('router'))
          }
        }
      }
      //  this.getObjArr('router') = router_list
      console.log(router_list)
    },
    async HcoGetHcoCatGroup_fn() {
      const { data } = await HcoGetHcoCatGroup()
      this.CatGroup_list = data.response
    },
    async HcoGetHcoRefGroup_fn() {
      const { data } = await HcoGetHcoRefGroup()
      this.RefGroup_list = data.response
    },
    async HcoGetVersionList_fn() {
      const { data } = await HcoGetVersionList()
      this.VersionList_list = data.response
    },
  },
  mounted() {
    if (localStorage.getItem('name_list')) {
      this.name_list = JSON.parse(localStorage.getItem('name_list'))
    }
    if (localStorage.getItem('zcn_list')) {
      this.zcn_list = JSON.parse(localStorage.getItem('zcn_list'))
    }
    // this.name_list = JSON.parse(localStorage.getItem('name_list'))
    // this.zcn_list =JSON.parse(localStorage.getItem('zcn_list'))
    this.isMobile = window.innerWidth <= 767
    console.log(this.isMobile)
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.isMobile) {
          this.tableHeight = window.innerHeight - 380
        } else {
          this.tableHeight = window.innerHeight - 250
        }
      })
    })
    console.log(this.tableHeight)
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    var user_details = JSON.parse(window.localStorage.getItem('user'))
    var user_RoleNames = user_details.RoleNames
    this.GLY_IF =
      user_RoleNames.filter(function (e) {
        return e == '管理员'
      }).length != 0
    console.log(this.$route.query)
    if (this.$route.query.filters_list !== '[object Object]' && this.$route.query !== undefined) {
      console.log(this.$route.query)
      if ('filters_list' in this.$route.query && this.$route.query.filters_list) {
        console.log(this.$route.query)
        this.filters = this.$route.query.filters_list
      }
    }
    // if(this.$route.query.filters_list !== "[object Object]" && this.$route.query.filters_list){
    //     console.log(111)
    //     if('filters_list' in this.$route.query){
    //         console.log(111)
    //         this.filters = this.$route.query.filters_list
    //     }
    // }
    this.getModules()
    this.HcoGetVersionList_fn()
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
    if (this.buttonList) {
      if (
        this.buttonList.filter(function (e) {
          return e.name == '编辑'
        }).length != 0
      ) {
        this.EDIT_IF = true
      }
      if (
        this.buttonList.filter(function (e) {
          return e.name == '编 辑'
        }).length != 0
      ) {
        this.EDIT_BCXX_IF = true
      }
      // this.buttonList = this.buttonList.filter(function (e) {
      //   return e.name != "编辑";
      // })
      if (
        this.buttonList.filter(function (e) {
          return e.name == '合并/删除'
        }).length != 0
      ) {
        this.HBSC_IF = true
      }
      this.buttonList = this.buttonList.filter(function (e) {
        return e.name != '合并/删除' && e.name != '编辑' && e.name != '编 辑'
      })
    }
    //  if (this.buttonList) {
    //     if (
    //       this.buttonList.filter(function (e) {
    //         return e.name == "批量更新";
    //       }).length != 0
    //     ) {
    //       this.PLGX_IF = true;
    //     }
    //     this.buttonList = this.buttonList.filter(function (e) {
    //       return e.name != "批量更新";
    //     })

    //   };
  },
}
</script>

<style scoped>
.el-select,
.el-date-editor,
.el-cascader {
  width: 100% !important;
}
</style>
